import script from "./buttonPanel.vue?vue&type=script&lang=js"
export * from "./buttonPanel.vue?vue&type=script&lang=js"

import "./buttonPanel.vue?vue&type=style&index=0&id=6bf5dbbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf5dbbe"]])

export default __exports__